
export function setAccounts(state,data) {
    state.accounts = data

}
export function setContactsLite(state,data) {
    state.contacts_lite = data
}

export function setReportData(state,data) {
    state.contact_balance = data
}




// WEBPACK FOOTER //
// ./src/modules/contact-balance/mutations.js